const chevronIconMap = {
  up: 'chevronUp',
  left: 'chevronLeft',
  down: 'chevronDown',
  right: 'chevronRight',
  block: 'lock',
}

export {chevronIconMap}
